<template>
  <div class="card shadow-0 ">
    <div class=" thead-bg-fafafa">
      <table
        class="table rounded"
        id="tb-product"
      >
        <thead>
          <tr>
            <th>{{ $t("Items") }} ({{ $parent.newAdjustment.countItemAll }})</th>
            <th style="width:170px">
              {{ $t("Type") }}
            </th>
            <th style="width:180px">
              {{ $t("_Inventory.Available QTY") }}
            </th>
            <th style="width:170px">
              {{ $t("Quantity") }}
            </th>
          </tr>
        </thead>
        <tbody
          :data-index="indexTbody"
        >
          <template v-for="(item, itemIndex) in $parent.newAdjustment.items">
            <template>
              <tr
                :key="itemIndex"
              >
                <td>
                  <div class="d-flex align-items-center ">
                    <a
                      @click="deleteItem(item)"
                      class="line-height-1"
                    ><i class="fa-minus-circle fas text-slate-400 fa-1x" /></a>
                    <img
                      :src="item.image"
                      class="thumb32 mx-3"
                    >
                    <div
                      class="item-content"
                      style="width: 350px;"
                    >
                      <div class="item-name">
                        <router-link
                          :to="{ name: 't.a.inventory-list', query: {link: encodeLink(JSON.stringify({productId: item.id}))}}"
                          target="_blank"
                        >
                          <span class="btn-link product-name text-wrap pointer mr-2">{{ item.name }}</span>
                        </router-link>
                        <!-- <span
                          v-show="item.attributes"
                          class="mr-2"
                        >{{ item.attributes.color }}-{{ item.attributes.size }}
                        </span> -->
                        <span
                          v-for="(variant, index) in item.product_variant"
                          :key="variant.id"
                          class="badge mr-1"
                          :class="[$storeIndex.badgeClass()[index]]"
                          style="min-width: auto;"
                        >
                          <i class="fa fa-tag" /> {{ variant }}
                        </span>
                        <span v-if="$storeIndex.isset(() => item.product.product_variant)">
                          <span
                            v-for="(variant, index) in item.product.product_variant"
                            :key="variant.id"
                            class="badge mr-1"
                            :class="[$storeIndex.badgeClass()[index]]"
                            style="min-width: auto;"
                          >
                            <i class="fa fa-tag" /> {{ variant.attribute_option.slug }}
                          </span>
                        </span>
                      </div>
                      <div class="item-bottom">
                        <span class="font-weight-bold text-sku">{{ 'SKU' }}: </span>
                          <span
                            v-if="item.sku"
                            class="text-muted cursor-auto"
                          >{{ item.sku }}</span>
                          <span
                            v-else
                            class="text-muted"
                          >
                            -
                          </span>
                        <p
                          class="text-danger"
                          v-if="item.available_qty < 1"
                        >
                          {{ $t('Left 0 Available QTY') }}
                        </p>
                      </div>
                      <div
                        v-if="item.sales_order_upsell_item"
                        class="item-bottom"
                      >
                        <span class="badge bg-success-400 px-2 mr-1"><i class="fa-solid fa-user-headset mr-1" />{{ $t('Upsell') }}</span>
                        <span class="text-muted mr-2">{{ item.sales_order_upsell_item.user.first_name }}</span>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <Select2
                    :id="'product-select2'+itemIndex"
                    name="product-select2"
                    v-model="item.type_adj"
                    :options="typeSelect2.typeOption"
                    :settings="typeSelect2.typeSetting"
                    @select="updateAllItem()"
                    disabled
                  />
                </td>
                <td>
                  <div class="align-items-center d-flex available_qty_box">
                    <div :class="item.available_qty > 0 ? 'text-success' : 'text-danger'">
                      <i class="fa-solid fa-warehouse-full mr-1" />
                      {{ item.available_qty | formatNumberNotZero }}
                    </div>
                  </div>
                </td>
                <td>
                  <div
                    class="mt-1"
                    style="width:130px;">
                    <span>{{ item.quantity }}</span>
                    <!-- <vue-numeric-input
                      v-if="item.type_adj == 'addition'"
                      :type="'text'"
                      :value="item.quantity"
                      controls-type="updown"
                      :min="1"
                      :step="1"
                      :precision="2"
                      @change="updateQty(item,$event)"
                    />
                    <vue-numeric-input
                      v-if="item.type_adj == 'subtraction'"
                      :type="'text'"
                      :value="item.quantity"
                      controls-type="updown"
                      :min="1"
                      :max="convertInt(item.available_qty)"
                      :step="1"
                      :precision="2"
                      @change="updateQty(item,$event)"
                    /> -->
                  </div>
                  <!-- <span
                    class="text-danger"
                    v-if="item.type_adj == 'subtraction' && item.quantity > item.available_qty"
                  >
                    {{ $t('Negative QTY Not Allowed') }}
                  </span> -->
                  <span
                    v-if="$parent.submitStatus && item.quantity > 9999999"
                    class="validation-invalid-label"
                    style="width: 120px;"
                    for="productInfo_name"
                  >
                    {{ $parent.errors['quantity'] }}
                  </span>
                </td>
              </tr>
            </template>
          </template>
        </tbody>


        <tr v-show="false">
          <td colspan="6">
            <div class="row">
              <div class="serach-product col-md-6">
                <div
                  id="product-search"
                  class="form-group form-group-feedback form-group-feedback-right mb-0"
                >
                  <Select2
                    class="search-product"
                    name="product"
                    @select="productSelectEvent($event)"
                    :settings="settingsProduct"
                    :placeholder="$t('Please Select Item...')"
                  />
                  <span
                    v-if="$parent.submitStatus"
                    class="validation-invalid-label"
                    v-html="$parent.errors['items']"
                  />
                </div>
              </div>

            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Api from '@/services/endpoint/tenant.service'
import Select2 from 'v-select2-component';
import VueNumericInput from 'vue-numeric-input';
import numeral from 'numeral'

export default {
    name: "OrderItem",
    props: {
    },
    components: {
        Select2,
        VueNumericInput,
    },
    data() {
        let self = this;
        let vm = this

        return {
            typeSelect2: {
                typeOption: [{
                        'id': 'addition',
                        'text': this.$t("Addition")
                    },
                    {
                        'id': 'subtraction',
                        'text': this.$t("Subtraction")
                    },
                ],
                typeSetting: {
                    minimumResultsForSearch: -1,
                    allowClear: false,
                    dropdownParent: '#action_modal',
                },
                typeValue: 1,
            },
            urlProduct: self.$parent.urlProduct,
            discountSymbol: this.$t('฿'),
            optionsProduct:{},
            settingsProduct: {
                language: {
                    noResults: this.noResults,
                },
                multiple: true,
                ajax: {
                    beforeSend: function (request) {
                        request.setRequestHeader("Authorization", 'Bearer ' + Api.AUTH.TOKEN);
                    },
                    url: this.$parent.urlProduct,
                    data: function (params) {
                        var query = {
                          search: params.term,
                          page: params.page || 1,
                          status: "active"
                            // customerId : self.$parent.newAdjustment.customer.id,
                        }
                        return Api.Signature.create($.param(query)).substring(1);
                    },
                    processResults: function (data, params) {
                      params.page = params.page || 1;
                      let product = data.data;
                      return {
                        results: product,
                        pagination: {
                          more: (params.page * 10) < data.meta.total
                        }
                      }
                    }
                },
                templateResult: this.templateProduct,
                templateSelection: this.templateCustomSelect,
                escapeMarkup: function (m) {
                    return m;
                },
                cache: true,
                allowClear: true,
            },
            indexTbody : 0,
            defaultImage: require("@/assets/images/no-image.png"),
        }
    },
    created() {
    },
    mounted: function () {
      this.feedData();
    },
    updated() {
        this.updateAllItem();
    },
    methods: {
      checkQty(data){
        if(data.available_qty == 0){
          let getOption = [{ 'id': 'addition', 'text': this.$t("Addition")}]
          return getOption;
        }
        return '';
      },
      getProduct (params) {
        var query = {
          search: params.term,
          page: params.page || 1
            // customerId : self.$parent.newAdjustment.customer.id,
        }
        return Api.Signature.create($.param(query)).substring(1);
      },
        isDecimalFormat(data){
            const array = data.toString();
            if(array.indexOf('.') != -1){
                if(parseInt(array.split(".")[1]) > 0){
                    return numeral(data).format("0,0.00");
                }
            }
            return numeral(data).format("0,0");
        },
        templateProduct(e) {
            let option = "";
            let skuNew = e.sku == '' || e.sku == null ? '-' : e.sku;
            let availableQty = e.available_qty == undefined || e.available_qty == 'undefined' ? 0 : e.available_qty;
            if (e.text == "Searching…") {
                option = this.$t("Searching...");
            } else {
                let stock = (e.quantity) ? e.quantity : 0;
                let stockColor = parseFloat(stock) <= 0 ? 'text-danger' : '';
                let attributes = ''
                var image = '<img class="thumb32 rounded mr-3" src="'+ this.$storeIndex.getImageSrc('channel/none') +'">';
                if (e.image != '') {
                    image = '<img class="thumb32 rounded mr-3" src="'+ (e.image ? e.image : '') +'">';
                }
                const productSimple = "<div class='font-weight-semibold item-name mr-2'>" + e.name +"</div><div class='item-bottom row ml-0'><span class='mr-1'>SKU: " + skuNew + ",</span><span>" + this.$t("Available QTY") + ": " + (this.isDecimalFormat(availableQty)) + "</span></div>";
                const productConfig = "<div class='font-weight-semibold item-name mr-2'>" + e.name + "<span class='px-2'>"+ attributes +"</span>"+"</div><div class='item-bottom row ml-0'><span class='mr-1'>SKU: " + skuNew + ",</span><span>" + this.$t("Available QTY") + ": " + (this.isDecimalFormat(availableQty)) + "</span></div>";
                option = "<div class='d-flex align-items-center'>";
                option += "<div class='item-image ml-1'>" + image + "</div><div class='item-content w-75'>";
                // option += "<div class='font-weight-semibold item-name'>" + e.name + "<span class='px-2'>"+ e.attributes.color + "</span>"+ "<span class='px-2'>"+ e.attributes.size + "</span>"+"</div><div class='item-bottom row ml-0'><span class='mr-2'>฿" + (this.isDecimalFormat(e.cost)) + ",</span><span class='mr-2 " + stockColor + "'>"+this.$t('Balance') + ": " + numeral(stock).format("0,0") + ",</span><span>SKU: " + skuNew + "</span></div>";
                option += e.attributes.color ? productConfig : productSimple;
                option += "</div>";
                option += "<div class='align-self-lg-stretch item-right text-right w-25'>";
                // if(e.attributes != undefined){
                //     e.attributes.forEach(function(value, index) {
                //         option += `<span class="variant option${index+1}"><i class="fa-solid fa-tag mr-1" ></i>${value.attribute_options[0].name}</span>`;
                //     })
                // }
                option += "</div>";
                option += "</div>";
            }
            return option;
        },
        templateCustomSelect(e) {
            return e.text;
        },

        findIndexItem(item){
            var index = 0;
            if(item.id){
                index = this.$parent.newAdjustment.items.findIndex(p => p.id == item.id );
            }else{
                index = this.$parent.newAdjustment.items.findIndex(p => p.product_id == item.product_id);
            }
            return index;
        },
        reCheckValidatePromotionQty(){
            if(this.$parent.PromotionIncompleteData.length > 0){
                let calPromotionQty = [];
                $.each(this.$parent.newAdjustment.items_promotion, async function (key, itemPromotion) {
                    if(!calPromotionQty[itemPromotion.promotion_id]) calPromotionQty[itemPromotion.promotion_id] = 0;
                    calPromotionQty[itemPromotion.promotion_id] += parseInt(itemPromotion.quantity);
                });

                let PromotionIncompleteData = [];
                $.each(this.$parent.PromotionIncompleteData, async function (key, inCompleteData) {
                    if(parseInt(inCompleteData.max_used_time) < calPromotionQty[inCompleteData.promotion_id]){
                        PromotionIncompleteData.push(inCompleteData);
                    }
                });
                this.$parent.PromotionIncompleteData = PromotionIncompleteData;
            }
        },
        deleteItem(item) {
          let index = this.findIndexItem(item);
          if(this.$parent.newAdjustment.items[index].promotion_group_id != null){
              this.reCheckValidatePromotionQty();

              let promotionGroupId = this.$parent.newAdjustment.items[index].promotion_group_id;

              let indexPromotion = this.$parent.newAdjustment.items_promotion.findIndex(promotion => promotion.group_id == promotionGroupId);
              this.$parent.newAdjustment.items_promotion.splice(indexPromotion, 1);

              this.$parent.newAdjustment.items = this.$parent.newAdjustment.items.filter(p => p.promotion_group_id != promotionGroupId);
          } else {
              this.$parent.newAdjustment.items.splice(index, 1);
          }
        },
        updateQty(item, qty) {
          let index = this.findIndexItem(item);
          let quantity = qty;
          if(!qty || qty < 0){
            quantity = 1;
          }
          this.$parent.newAdjustment.items[index].quantity = quantity;
          this.$parent.newAdjustment.items[index].ordered_quantity = quantity;
          this.updateAllItem();
        },

        updateAllItem() {
          let items = this.$parent.newAdjustment.items;
          let countItemAll = 0;
          for (let i = 0; i < this.$parent.newAdjustment.items.length; i++) {
              let item = items[i];
              let index = this.findIndexItem(item);
              countItemAll= countItemAll +1;
          }
          this.$parent.newAdjustment.countItemAll = countItemAll;

        },
        onlyNumber($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                $event.preventDefault();
            }
        },
        async feedData() {
          var self = this;
          try {
            let queryParams={};

            queryParams.limit = 10;
            queryParams.page = 1;
            let queryString = "";
            if (queryParams) {
              queryString += "?" + $.param(queryParams);
            }
          }catch(err) {
            console.log('err',err);
          }
          this.onloadPage = false;
        },
        convertInt(num){
          return parseInt(num);
        },
        productSelectEvent(e) {
            let self = this;
            var image = this.$storeIndex.getImageSrc('channel/none');
            if (e.image) {
              image = e.image;
            }
            let item = {
                "id": e.id,
                "available_qty": e.available_qty,
                "attributes": e.attributes,
                "product_id": e.id,
                "cost": e.cost,
                "sku": e.sku,
                "curency": e.curency,
                "name": e.name,
                "image": image,
                "quantity": (e.qty) ? parseInt(e.qty) : 1,
                "cost": e.cost,
                "status": e.status,
                "total": e.cost,
                "is_vat": e.is_vat,
                "type_adj": (e.type_adj) ? e.type_adj : 'addition',
            };
            if(e["replaceIndex"] !== undefined){
                this.$parent.newAdjustment.items[e["replaceIndex"]] = item;
            } else {
                var index = this.findIndexItem(item);
                if (index < 0) {
                    this.$parent.newAdjustment.items.push(item);
                } else {
                    let itemUpdate = this.$parent.newAdjustment.items[index];
                    let quantity = itemUpdate.quantity;
                    this.updateQty(item, (quantity + 1))
                }
            }

            $('select[name=product]').val(null).trigger('change');
            this.indexTbody++;//for update data in array
        },
        async promotionSelectEvent(bundleProduct){
            let self = this;
            await $.each(bundleProduct, async function (key, bundle) {
                let e = bundle.product;
                e.promotion_section_item =[];
                e.promotion_qty = bundleProduct.qty;

                self.productSelectEvent(e);
            });
        },
        noResults() {
            return this.$t('No Result Found');
        },
        setMaxPromotionQty(item){
            let purchaseLimit = null;

            if(item.max_used_time != null){
                purchaseLimit = parseInt(item.max_used_time);
            }

            if(item.max_customer_used_time != null){
                purchaseLimit = parseInt(item.max_customer_used_time);
            }

            if(purchaseLimit != null && item.used_orders_count != null){
                purchaseLimit = purchaseLimit - parseInt(item.used_orders_count);
            }

            if(purchaseLimit == null) purchaseLimit = Infinity;

            return purchaseLimit;
        },
        getPromotionIncompleteData(promotionId){
            let incompleteData = (this.$parent.PromotionIncompleteData).find(p => p.promotion_id === promotionId);
            if(incompleteData){
              if(incompleteData.type == 'expire'){
                return 'Promotions Expired';
              } else {
                return (incompleteData.max_used_time < 0 ? 0 : incompleteData.max_used_time) + ' Promotions left';
              }
            } else {
                return '';
            }
        },
        encodeLink (data) {
          return btoa(data)
        },
    },
    filters: {
      formatNumber: function (value) {
          return numeral(value).format("0,0.00");
      },
      formatNumberNotZero(value) {
          return numeral(value).format("0,0");
      },
      replaceTextBuy: function (text, value) {
          if(!text) return;
          return text.replace('{buy}', numeral(value).format("0,0") || "0");
      },
      replaceTextGet: function (text, value, rule) {
        if(!text) return;

        value = numeral(value).format("0,0.00");
        if(rule == 3) value = numeral(value).format("0,0");

        return text.replace('{get}', value || "0");
      },
    },
    watch: {
    }
}
</script>

<style>
    .thumb32 {
        width:32px;
        height:32px;
        object-fit: cover;
    }
    .variant{
        border-radius: 3px;
        color: #FFFF;
        padding: 3px 5px;
        font-size: 9px;
    }
    .option1{
        background: #607D8B;
    }
    .option2{
        background: #29B6F6;
        margin-left: .3125rem !important;
    }
    .badge-secondary{
        background: #607D8B !important;
    }
    .select2 {
        width:100%!important;
    }
    .promotion-collapsed.collapsed span.cursor-pointer > .fa-angle-up:before {
        content: "\f107";
    }
    #product-search li.select2-search.select2-search--inline {
      width: 100%;
      padding-right: 25px;
    }
    #product-search li.select2-search input.select2-search__field {
      width: 100%;
    }
    .search-product .select2-container--default .select2-selection--multiple .select2-search--inline:first-child .select2-search__field {
      min-width: 12rem!important;
      max-width: 16.5rem!important;
    }
    #tb-product td{
      vertical-align: top;
    }
    .available_qty_box{
      height: 36px;
      padding: 0;
      border-radius: 0.1875rem;
      background: inherit;
    }
    .btn-link.product-name:hover {
      text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/restock/OrderItem.vue